import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';
import PaymentIcons from './PaymentIcons';

const Footer = () => {
  const navigate = useNavigate();

  const handleCustomizeClick = () => {
    navigate('/customize');
  };

  return (
    <footer className="border-t bg-muted/40 mt-0">
      <div className="container px-4 md:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <a href="/" className="flex items-center gap-2 mb-3 w-fit">
              <img src="/images/logo.svg" alt="Dekalio" className="h-6 w-6" />
              <span className="font-semibold">Dekalio</span>
            </a>
            <p className="text-sm text-muted-foreground">
              Professionell bildekor och fordonsprofilering
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Produkt</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Button variant="link" className="h-auto p-0" onClick={handleCustomizeClick}>Bilmodeller</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/faq')}>FAQ</Button></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/support')}>Support</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/om-oss')}>Om oss</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/kontakt')}>Kontakt</Button></li>
            </ul>
            </div>

          <div>
            <h3 className="font-semibold mb-4">Juridiskt</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/integritetspolicy')}>Integritetspolicy</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/villkor')}>Villkor</Button></li>
              <li><Button variant="link" className="h-auto p-0" onClick={() => navigate('/cookies')}>Cookies</Button></li>
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Dekalio. All rights reserved.</p>
          <PaymentIcons className="opacity-80 hover:opacity-100 transition-opacity" />
        </div>
      </div>
    </footer>
  );
};

export default Footer; 